/** @flow */

import * as actions from "@modules/shared/constants/actions";
import * as alertSuppressionReducer from "./reducers";
import initialState from "./state";
import type { AlertSuppressionState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: AlertSuppressionState = initialState, action: *): AlertSuppressionState => {
  const act = {
    [actions.GetAlertsSuppressedBy]: alertSuppressionReducer.onGetAlertsSuppressedBy,
    [actions.GetAlertsSuppressedBySuccess]: alertSuppressionReducer.onGetAlertsSuppressedBySuccess,

    [actions.GetAlertsSuppression]: alertSuppressionReducer.onGetAlertsSuppression,
    [actions.GetAlertsSuppressionSuccess]: alertSuppressionReducer.onGetAlertsSuppressionSuccess,
    [actions.GetAlertsSuppressionError]: alertSuppressionReducer.onGetAlertsSuppressionError,

    [actions.AddAlertsSuppression]: alertSuppressionReducer.onAddAlertsSuppression,
    [actions.AddAlertsSuppressionSuccess]: alertSuppressionReducer.onAddAlertsSuppressionSuccess,
    [actions.AddAlertsSuppressionError]: alertSuppressionReducer.onAddAlertsSuppressionError,

    [actions.GetAlertsSuppressionOptions]: alertSuppressionReducer.onGetAlertsSuppressionOptions,
    [actions.GetAlertsSuppressionOptionsSuccess]:
      alertSuppressionReducer.onGetAlertsSuppressionOptionsSuccess,
    [actions.GetAlertsSuppressionOptionsError]:
      alertSuppressionReducer.onGetAlertsSuppressionOptionsError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
